var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.916 9.1665H14.666V11.9165H11.916V18.3332H9.16602V11.9165H6.41602V9.1665H9.16602V8.01609C9.16602 6.92617 9.50885 5.54934 10.1908 4.79675C10.8728 4.04264 11.7241 3.66589 12.7447 3.6665H14.666V6.4165H12.741C12.2845 6.4165 11.916 6.785 11.916 7.24059V9.1665Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFace);
export default __webpack_public_path__ + "static/media/ic_face.0876d03f49b7bb0d965daa16d518aaeb.svg";
export { ForwardRef as ReactComponent };